var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2469 7.32824H15.5416C13.8172 7.33127 12.4203 8.69325 12.4172 10.3745C12.4149 12.0595 13.8133 13.4276 15.5416 13.4299H19.25V13.6975C19.25 16.6369 17.4681 18.375 14.4527 18.375H6.54811C3.53189 18.375 1.75 16.6369 1.75 13.6975V7.29563C1.75 4.35629 3.53189 2.625 6.54811 2.625H14.4496C17.465 2.625 19.2469 4.35629 19.2469 7.29563V7.32824ZM5.89711 7.32141H10.8321H10.8352H10.8414C11.2109 7.31989 11.5096 7.02642 11.508 6.66544C11.5064 6.30523 11.2047 6.01403 10.8352 6.01555H5.89711C5.53 6.01706 5.23211 6.30751 5.23056 6.6662C5.229 7.02642 5.52767 7.31989 5.89711 7.32141Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.0327 10.7597C14.2157 11.592 14.9454 12.1775 15.7785 12.1623H18.6222C18.9688 12.1623 19.25 11.8752 19.25 11.5204V9.30528C19.2493 8.95119 18.9688 8.66336 18.6222 8.6626H15.7116C14.7639 8.66564 13.9985 9.45224 14 10.4216C14 10.535 14.0112 10.6485 14.0327 10.7597Z",
    fill: "#E9A5F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.75,
    cy: 10.4126,
    r: 0.875,
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.a2cdbfee23884977f48be0ab7fe1f6bf.svg";
export { ForwardRef as ReactComponent };